import React, { useEffect, useState } from 'react'
import useApi from '../../api';
import { toast } from 'react-toastify';
import { NXCheck, NXCross } from '../../icons';
import { NxtbnDrawer } from '../../components';

interface StockViewProps{
    id: number;
    isOpen: boolean;
    onClose: ()=>void;
}

function StockView({id, isOpen, onClose}:StockViewProps) {
    const [stock, setStock] = useState<any>()

    const api = useApi()

    useEffect(()=>{
        if (id){
            api.getDetailStock(id).then((response:any)=>{
                setStock(response)
            }).catch((error)=>toast.error('Error get details stock'))
        }
    }, [id])


  return (
    <NxtbnDrawer isOpen={isOpen} onClose={onClose} title='Stock Detail'>
        <div>
            <div className='p-4 border shadow-lg rounded-lg mb-4 flex flex-col gap-2'>
                <h3>Stock Info</h3>
                <div>
                    <div><strong>Stock ID: </strong>{stock?.id}</div>
                    <div><strong>Quantity: </strong>{stock?.quantity}</div>
                </div>
            </div>
            <div>
                <div className="p-4 border shadow-lg rounded-lg mb-4 flex flex-col gap-2">
                    <h3>Warehouse Info</h3> 
                    <div>
                        <div><strong>ID: </strong>{stock?.warehouse.id}</div>
                        <div><strong>Country: </strong>{stock?.warehouse.name}</div>
                        <div><strong>State:  </strong>{stock?.warehouse.location}</div>
                    </div>
                </div>
            </div>
            <div>
                <div className="p-4 border shadow-lg rounded-lg mb-4 flex flex-col gap-2">
                    <h3>Product Variant Info</h3> 
                    <div>
                        <div><strong>ID: </strong>{stock?.product_variant.id}</div>
                        <div><strong>Variant Name: </strong>{stock?.product_variant.name}</div>
                        <div><strong>Price: </strong>${stock?.product_variant.price}</div>
                        <div><strong>SKU:  </strong>{stock?.product_variant.sku}</div>
                        <div><strong>Alias:  </strong>{stock?.product_variant.alias}</div>
                        <div><strong>Product ID:  </strong>{stock?.product_variant.product}</div>

                        <div><strong>Product Name:  </strong>{stock?.product_variant.product_name}</div>
                        <div><strong>Low Stock Threshold:  </strong>{stock?.product_variant.low_stock_threshold}</div>
                        <div><strong>Cost Per Unit:  </strong>{stock?.product_variant.cost_per_unit}</div>
                        <div><strong>Compare at Price:  </strong>{stock?.product_variant.compare_at_price}</div>
                        <div><strong>Color code:  </strong>{stock?.product_variant.color_code}</div>
                        <div className='flex items-center gap-2'><strong>Track Inventory:  </strong>{stock?.product_variant.track_inventory ? <NXCheck/> : <NXCross className='w-4 h-4 stroke-red-600'/>}</div>
                        <div><strong>Weight Value:  </strong>{stock?.product_variant.weight_value}</div>
                        <div><strong>Stock:  </strong>{stock?.product_variant.stock}</div>
                        <div><strong>Stock Status:  </strong>{stock?.product_variant.stock_status}</div>
                    </div>

                </div>
            </div>
        </div>
    </NxtbnDrawer>
  )
}

export default StockView